/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ApprovalReportItemType {
  None = 'None',
  Downtime = 'Downtime',
  ProductionOrder = 'ProductionOrder',
  ProductionOrderRunPhase = 'ProductionOrderRunPhase',
  DowntimeDetail = 'DowntimeDetail',
  ConsumptionArticle = 'ConsumptionArticle',
  ConsumptionMaterial = 'ConsumptionMaterial',
  RunDetail = 'RunDetail',
  SetupDetail = 'SetupDetail'
}
